module.exports = __webpack_public_path__ + "static/media/drag.da49e810.svg";